import {format, isValid, parseISO as parseISOHelper} from "date-fns";


export function getCurrentDate(): string {
	return format(new Date(), "yyyy-MM-dd");
}


export function isValidDate(dateString: string): boolean {
	try {
		const date = parseISODate(dateString);
		if (!isValid(date)) {
			return false;
		}
		if (isoFormatDate(date) !== dateString) {
			return false;
		}
	} catch {
		return false;
	}
	
	return true;
}


export function parseISODate(dateString: string): Date {
	return parseISOHelper(dateString)
}


export function prettyFormatDate(date: Date | number | string): string {
	return format(date, "PPP");
}


export function isoFormatDate(date: Date | number | string): string {
	return format(date, "yyyy-MM-dd");
}
